import { Component, OnInit, Input, Output, EventEmitter, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppModule } from '../../../app-module';
import { AcuseComponent } from '../Acuse/acuse.component';
import { DemandaDetalleComponent } from '../demanda-detalle/demanda-detalle.component';


@Component({
  selector: 'oaj-dialog-itx',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css'],
  imports: [AppModule, AcuseComponent, DemandaDetalleComponent]
})
export class DialogComponent implements OnInit {

  @Input() data: any;
  titulo!: string;
  @Output() response = new EventEmitter<any>();
  tituloAcuse!: string;
  private activeModel: NgbActiveModal = inject(NgbActiveModal);

  ngOnInit(): void {
    // console.log(this.data);  
    this.titulo = this.data?.Title || 'Diálogo';
  }

  closeClick() {
    this.activeModel.close('cancelar');
    this.response.emit('cancelar');
  }

  dismissClick() { this.closeClick(); }

}
